import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [{
	path: '/',
	redirect: {
		name: 'index'
	},
	component: layoutHeaderAside,
	children: [
		{
			path: 'KyReviewInfo',
			name: 'KyReviewInfo',
			meta: {
				title: '科研项目评审',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Project/KyReviewInfo/KyReviewInfo')
		},
		{
			path: 'StandReport',
			name: 'StandReport',
			meta: {
				title: '标准发布统计',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Reports/StandReport/StandReport')
		},
		{
			path: 'MonographReport',
			name: 'MonographReport',
			meta: {
				title: '专著发布统计',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Reports/MonographReport/MonographReport')
		},
		{
			path: 'PatentReport',
			name: 'PatentReport',
			meta: {
				title: '专利申请统计',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Reports/PatentReport/PatentReport')
		},
		{
			path: 'DocReReport',
			name: 'DocReReport',
			meta: {
				title: '论文发表统计',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Reports/DocReReport/DocReReport')
		},
		{
			path: 'KyPjReport',
			name: 'KyPjReport',
			meta: {
				title: '科研项目统计',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Reports/KyPjReport/KyPjReport')
		},
		{
			path: 'KyAssInfo',
			name: 'KyAssInfo',
			meta: {
				title: '外协情况',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Project/KyAssInfo/KyAssInfo')
		},
		{
			path: 'KyItemInfo',
			name: 'KyItemInfo',
			meta: {
				title: '固定资产',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Project/KyItemInfo/KyItemInfo')
		},
		{
			path: 'KyContractInfo',
			name: 'KyContractInfo',
			meta: {
				title: '采购合同',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Project/KyContractInfo/KyContractInfo')
		},
		
		
		// 首页
		{
			path: 'index',
			name: 'index',
			meta: {
				auth: true
			},
			component: _import('system/index')
		},
		// 系统 前端日志
		{
			path: 'log',
			name: 'log',
			meta: {
				title: '前端日志',
				auth: true
			},
			component: _import('system/log')
		},
		// 刷新页面 必须保留
		{
			path: 'refresh',
			name: 'refresh',
			hidden: true,
			component: _import('system/function/refresh')
		},
		// 页面重定向 必须保留
		{
			path: 'redirect/:route*',
			name: 'redirect',
			hidden: true,
			component: _import('system/function/redirect')
		},
		// 下面都是我的页面：
		{
			path: 'UserInfo',
			name: 'UserInfo',
			meta: {
				title: '用户及权限',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/UserInfo/UserInfo')
		},{
			path: 'UpdateLogInfo',
			name: 'UpdateLogInfo',
			meta: {
				title: '更新日志',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/UpdateLogInfo/UpdateLogInfo')
		},{
			path: 'MenuInfo',
			name: 'MenuInfo',
			meta: {
				title: '系统菜单设置',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/MenuInfo/MenuInfo')
		},{
			path: 'DocReInfo',
			name: 'DocReInfo',
			meta: {
				title: '论文发表',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Study/DocReInfo/DocReInfo')
		},{
			path: 'NoticeInfo',
			name: 'NoticeInfo',
			meta: {
				title: '公告管理',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/NoticeInfo/NoticeInfo')
		},{
			path: 'PatentInfo',
			name: 'PatentInfo',
			meta: {
				title: '专利申请',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Study/PatentInfo/PatentInfo')
		},{
			path: 'AskInfo',
			name: 'AskInfo',
			meta: {
				title: '咨询报告',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Study/AskInfo/AskInfo')
		},{
			path: 'StandInfo',
			name: 'StandInfo',
			meta: {
				title: '标准发布',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Study/StandInfo/StandInfo')
		},{
			path: 'MonographInfo',
			name: 'MonographInfo',
			meta: {
				title: '专著发布',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Study/MonographInfo/MonographInfo')
		},{
			path: 'TechInfo',
			name: 'TechInfo',
			meta: {
				title: '科技服务',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Service/TechInfo/TechInfo')
		},{
			path: 'DrillInfo',
			name: 'DrillInfo',
			meta: {
				title: '演练保障',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Service/DrillInfo/DrillInfo')
		},{
			path: 'ExpertInfo',
			name: 'ExpertInfo',
			meta: {
				title: '专家咨询',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Service/ExpertInfo/ExpertInfo')
		},{
			path: 'KyProjectInfo',
			name: 'KyProjectInfo',
			meta: {
				title: '科研项目',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Project/KyProjectInfo/KyProjectInfo')
		},{
			path: 'RewardTechInfo',
			name: 'RewardTechInfo',
			meta: {
				title: '科技成果奖励',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Reward/RewardTechInfo/RewardTechInfo')
		},{
			path: 'RewardPersonInfo',
			name: 'RewardPersonInfo',
			meta: {
				title: '个人科研荣誉',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Reward/RewardPersonInfo/RewardPersonInfo')
		},{
			path: 'TeamInfo',
			name: 'TeamInfo',
			meta: {
				title: '团队建设情况',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Team/TeamInfo/TeamInfo')
		},{
			path: 'KyProfitInfo',
			name: 'KyProfitInfo',
			meta: {
				title: '绩效发放',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Project/KyProfitInfo/KyProfitInfo')
		},{
			path: 'RewardTeamInfo',
			name: 'RewardTeamInfo',
			meta: {
				title: '团队科研荣誉',
				auth: true,
				cache: true,//启动缓存
			},
			component: _import('pages/Reward/RewardTeamInfo/RewardTeamInfo')
		},
		
		
	]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [
	// 登录
	{
		path: '/login',
		name: 'login',
		component: _import('system/login')
	}
]

/**
 * 错误页面
 */
const errorPage = [{
	path: '*',
	name: '404',
	component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
	...frameIn,
	...frameOut,
	...errorPage
]
